@if (showCookiesMessage) {
    <div class="cookies">
        <div class="cookies__content">
            <p class="cookies__message _system-p _system-p-sm _400">
                {{ cookiesMessage | translate }}
                <a
                    class="link _primary"
                    [href]="'/info/privacy-policy' | localize"
                >{{ 'common.cookies-link' | translate }}</a>
            </p>
            <button
                class="cookies__btn"
                lsUiButtonKind="basic"
                lsUiButtonPalette="neutral-1"
                lsUiButtonSize="medium"
                (click)="acceptCookies()"
            >
                {{ 'common.button-accept' | translate }}
            </button>
        </div>
    </div>
}
